import { PcrProtocol } from 'entities/pcr_protocol'
import { ViewModel } from 'view_models/view_model'

export class PcrProtocolViewModel extends ViewModel<PcrProtocol> {
    public name = () => {
        return `${this.object.sampleCount}cDNA x ${this.object.probeCount}probes`
    }
}
